/* eslint-disable import/prefer-default-export */
import { DEVICE } from './drawers.c';

/**
 * Tells whether a study's recording device is an iCor unit, which gates iCor-only fields in the info drawers. Optional-chains the device model and compares it against the iCor entry of the DEVICE constant, so a missing device or model yields false.
 *
 * @param device - Device record whose model is checked; may be undefined.
 * @returns True when the device model is iCor.
 */
const checkIcorDevice = (device?: { model?: string }) => device?.model === DEVICE.ICOR;

export { checkIcorDevice };
